import React from 'react';
import { useTranslation } from 'react-i18next';

const StockTransfers = ({ organization }) => {
  const { t } = useTranslation();
  return (
    <div className="pm-page-card">
      <div className="pm-empty-state-compact">
        <div className="pm-empty-state-icon" aria-hidden="true">🔄</div>
        <h3>{t('inventory.stock_transfers_title')}</h3>
        <p>{t('inventory.coming_soon')}</p>
      </div>
    </div>
  );
};

export default StockTransfers;
